export default __webpack_public_path__ + "static/tourist-traps-7-useful-tactics-and-how-to-avoid-them-money-7bde2c37c937bc9d27a937014500d0a8.jpg";